import { createContext , useState} from "react";

interface ChildrenNode {
    children: React.ReactNode
}

const AppDataContext = createContext({
  isHeaderShow: true,
  setHeaderShow: (isHeaderShow: boolean) => {},

  isGridModalShow: true,
  setGridModalShow: (isGridModalShow: boolean) => {},
  isAddModalShow: true,
  setAddModalShow: (isGridModalShow: boolean) => {},

  isInboxShow: false,
  setInboxShow: (isHeaderShow: boolean) => {},
  isShowModal: false,
  setToggleModal: (isHeaderShow: boolean) => {},
  navText: "risk-health",
  setNavText: (isHeaderShow: string) => {},
  headerData: {},
  setHeaderData: (headerData: any) => {},
  user: {},
  setUser: (user: any) => {},
  isShowBackArrow: false,
  setShowBackArrow: (isShowBackArrow: boolean) => {},

  isRHSModalShow: true,
  setRHSModalShow: (isRHSModalShow: boolean) => {},

});


export const AppDataProvider = ({children}: ChildrenNode)=> {
    const [headerData, setHeaderData] = useState({});
    const [isHeaderShow, setHeaderShow] = useState(true);
    const [isInboxShow, setInboxShow] = useState(false);
    const [user, setUser] = useState({});
    const [isShowBackArrow, setShowBackArrow] = useState(false);
    const [isShowModal, setToggleModal] = useState(false);
    const [navText, setNavText] = useState("risk-health");
    const [isGridModalShow, setGridModalShow] = useState(false);
    const [isAddModalShow, setAddModalShow] = useState(false);
    const [isRHSModalShow, setRHSModalShow] = useState(false);

    return (
      <AppDataContext.Provider
        value={{
          headerData,
          setHeaderData,
          isHeaderShow,
          setHeaderShow,
          isInboxShow,
          setInboxShow,
          user,
          setUser,
          isShowBackArrow,
          setShowBackArrow,
          isShowModal,
          setToggleModal,
          navText,
          setNavText,
          isGridModalShow,
          setGridModalShow,
          isAddModalShow,
          setAddModalShow,
          isRHSModalShow,
          setRHSModalShow,
        }}
      >
        {children}
      </AppDataContext.Provider>
    );

}


export default AppDataContext;